/**
 * Unlock AudioContext after user gesture (helps `<audio>` and Web Audio on strict browsers).
 */

let audioCtx = null;

export function getAudioContext() {
  if (typeof window === "undefined") return null;
  if (!audioCtx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    audioCtx = new AC();
  }
  return audioCtx;
}

export async function resumeAudioContext() {
  const ctx = getAudioContext();
  if (!ctx) return;
  if (ctx.state === "suspended") {
    await ctx.resume();
  }
}

let gestureAttached = false;

export function attachAudioGestureOnce() {
  if (typeof window === "undefined" || gestureAttached) return;
  gestureAttached = true;
  const go = () => {
    void resumeAudioContext();
  };
  window.addEventListener("pointerdown", go, { passive: true, capture: true });
  window.addEventListener("keydown", go, { passive: true, capture: true });
}
